<template>
  <div>
    <v-alert type="info" dense text>
      The whole report as one JSON document - what is stored, exported and imported. Edit it directly if you prefer; press <b>Apply</b> to load your changes into the other tabs.
    </v-alert>
    <div class="d-flex align-center mb-2">
      <v-btn small color="primary" :disabled="!!parseError" @click="apply"><v-icon left small>mdi-check</v-icon>Apply to editor</v-btn>
      <v-btn small text class="ml-2" @click="refresh"><v-icon left small>mdi-refresh</v-icon>Reload from editor</v-btn>
      <span v-if="parseError" class="ml-3 error--text text-caption">{{ parseError }}</span>
    </div>
    <code-box :value="text" mode="json" :rows="30" :max-height="640" @input="onInput" />
  </div>
</template>

<script>
import CodeBox from './CodeBox.vue'
import { state } from './editorState'

export default {
  name: 'RbJsonTab',
  components: { CodeBox },
  data () {
    return { text: '', parseError: '' }
  },
  created () { this.refresh() },
  methods: {
    refresh () {
      this.text = JSON.stringify(state.tpl, null, 2)
      this.parseError = ''
    },
    onInput (v) {
      this.text = v
      try { JSON.parse(v); this.parseError = '' } catch (e) { this.parseError = e.message }
    },
    apply () {
      try {
        const t = JSON.parse(this.text)
        if (!t || typeof t !== 'object') throw new Error('Not an object')
        t.params = t.params || []
        t.info = t.info || []
        t.drilldowns = t.drilldowns || []
        t.exports = t.exports || []
        t.prints = t.prints || []
        t.permissions = t.permissions || { userTypeIds: [] }
        t.permissions.userTypeIds = t.permissions.userTypeIds || []
        t.tags = t.tags || []
        t.tests = t.tests || { fixtures: {}, cases: [], reconciliations: [] }
        t.ui = t.ui || { sections: [] }
        t.datasets = t.datasets || []
        state.tpl = t
        state.ctx = 'main'
        this.$snack('Applied.', 'success')
      } catch (e) {
        this.parseError = e.message
      }
    }
  }
}
</script>
